const LANDING_CONTENT = {
  "losetas-de-concreto": {
    heroCollectionId: "muro",
    relatedCollectionIds: ["muro", "pisos", "paneles"],
    locales: {
      "es-MX": {
        seoTitle: "Losetas de concreto para muros y fachadas | Arista + Vértice",
        seoDescription:
          "Descubre losetas de concreto y losetas 3D para muros decorativos, fachadas e interiorismo premium. Materiales para arquitectos, interioristas y proyectos de alto valor visual.",
        keywords: ["losetas de concreto", "losetas 3D", "muros decorativos", "revestimientos de concreto"],
        kicker: "Landing SEO",
        title: "Losetas de concreto con presencia arquitectónica y detalle material.",
        intro:
          "Esta landing reúne una lectura editorial de las losetas de concreto de Arista + Vértice para proyectos donde la textura, el volumen y la composición del muro son parte de la experiencia espacial.",
        benefitsTitle: "Por qué especificarlas",
        benefits: [
          "Aportan profundidad visual y una lectura escultórica en muros interiores o exteriores.",
          "Permiten combinar relieve, textura y color para crear composiciones sobrias o protagónicas.",
          "Funcionan como materiales para arquitectos e interioristas que buscan diferenciación sin perder durabilidad.",
        ],
        applicationsTitle: "Aplicaciones ideales",
        applications: ["Muros decorativos", "Interiorismo residencial", "Hospitality", "Fachadas arquitectónicas"],
        faqTitle: "Preguntas frecuentes sobre losetas de concreto",
        faq: [
          {
            question: "¿Qué diferencia hay entre una loseta de concreto y un revestimiento convencional?",
            answer: "Una loseta de concreto arquitectónico aporta masa visual, relieve y una lectura material más auténtica, ideal para proyectos de interiorismo y arquitectura premium.",
          },
          {
            question: "¿Se pueden usar en interior y exterior?",
            answer: "Sí. Dependiendo del modelo, la colección puede especificarse en muros interiores, fachadas, áreas semiexteriores y aplicaciones decorativas de alto tránsito visual.",
          },
          {
            question: "¿Puedo combinarlas con otros formatos?",
            answer: "Sí. Varias familias de Arista + Vértice están diseñadas para convivir con paneles, celosías o piezas compatibles dentro del mismo lenguaje material.",
          },
        ],
      },
      "es-ES": {
        seoTitle: "Losetas de hormigón para muros y fachadas | Arista + Vértice",
        seoDescription:
          "Descubre losetas de hormigón y losetas 3D para muros decorativos, fachadas e interiorismo premium. Materiales para arquitectos, interioristas y proyectos de alto valor visual.",
        keywords: ["losetas de hormigón", "losetas 3D", "muros decorativos", "revestimientos de hormigón"],
        kicker: "Landing SEO",
        title: "Losetas de hormigón con presencia arquitectónica y detalle material.",
        intro:
          "Esta landing reúne una lectura editorial de las losetas de hormigón de Arista + Vértice para proyectos donde la textura, el volumen y la composición del muro forman parte de la experiencia espacial.",
        benefitsTitle: "Por qué prescribirlas",
        benefits: [
          "Aportan profundidad visual y una lectura escultórica en muros interiores o exteriores.",
          "Permiten combinar relieve, textura y color para crear composiciones sobrias o protagonistas.",
          "Funcionan como materiales para arquitectos e interioristas que buscan diferenciación sin perder durabilidad.",
        ],
        applicationsTitle: "Aplicaciones ideales",
        applications: ["Muros decorativos", "Interiorismo residencial", "Hospitality", "Fachadas arquitectónicas"],
        faqTitle: "Preguntas frecuentes sobre losetas de hormigón",
        faq: [
          {
            question: "¿Qué diferencia hay entre una loseta de hormigón y un revestimiento convencional?",
            answer: "Una loseta de hormigón arquitectónico aporta masa visual, relieve y una lectura material más auténtica, ideal para proyectos de interiorismo y arquitectura premium.",
          },
          {
            question: "¿Se pueden usar en interior y exterior?",
            answer: "Sí. Dependiendo del modelo, la colección puede prescribirse en muros interiores, fachadas, áreas semiexteriores y aplicaciones decorativas de alto tránsito visual.",
          },
          {
            question: "¿Puedo combinarlas con otros formatos?",
            answer: "Sí. Varias familias de Arista + Vértice están diseñadas para convivir con paneles, celosías o piezas compatibles dentro del mismo lenguaje material.",
          },
        ],
      },
      "en-US": {
        seoTitle: "Concrete wall tiles for premium interiors | Arista + Vértice",
        seoDescription:
          "Discover concrete wall tiles and 3D concrete tiles for decorative walls, premium interiors and architectural facades. A refined material system for design-led projects.",
        keywords: ["concrete wall tiles", "3D concrete tiles", "decorative walls", "architectural concrete finishes"],
        kicker: "SEO landing",
        title: "Concrete wall tiles with sculptural depth and material character.",
        intro:
          "This landing page translates Arista + Vértice wall tile systems into a clearer search experience for architects and interior designers looking for premium concrete finishes.",
        benefitsTitle: "Why specify them",
        benefits: [
          "They add depth, shadow and architectural texture to interior or exterior walls.",
          "They support calm, sculptural or highly expressive compositions depending on the layout.",
          "They help design teams work with a premium material that feels distinctive and specification-ready.",
        ],
        applicationsTitle: "Ideal applications",
        applications: ["Feature walls", "Residential interiors", "Hospitality", "Architectural facades"],
        faqTitle: "Frequently asked questions about concrete wall tiles",
        faq: [
          {
            question: "What makes concrete wall tiles different from regular wall cladding?",
            answer: "Architectural concrete wall tiles bring mass, depth and a more tactile material expression, making them ideal for premium interior design and facade applications.",
          },
          {
            question: "Can they be used indoors and outdoors?",
            answer: "Yes. Depending on the model, they can be specified for interior walls, facades, semi-outdoor spaces and design-driven commercial environments.",
          },
          {
            question: "Can they be combined with other products?",
            answer: "Yes. Several Arista + Vértice families can be combined with compatible pieces, panels or screens to build broader material systems.",
          },
        ],
      },
    },
  },
  "celosias-de-concreto": {
    heroCollectionId: "celosias",
    relatedCollectionIds: ["celosias", "paneles", "muro"],
    locales: {
      "es-MX": {
        seoTitle: "Celosías de concreto para fachadas | Arista + Vértice",
        seoDescription:
          "Explora celosías de concreto para fachadas, filtros visuales, ventilación y privacidad. Soluciones arquitectónicas premium con luz, sombra y profundidad.",
        keywords: ["celosías de concreto", "fachadas arquitectónicas", "muros divisorios", "concrete screens"],
        kicker: "Landing SEO",
        title: "Celosías de concreto para fachadas con ritmo, luz y sombra.",
        intro:
          "Las celosías de Arista + Vértice convierten la envolvente arquitectónica en una superficie activa: filtran la luz, aportan privacidad y construyen un gesto formal con carácter premium.",
        benefitsTitle: "Valor para proyecto",
        benefits: [
          "Mejoran la relación entre sombra, ventilación y privacidad sin sacrificar expresión arquitectónica.",
          "Funcionan en fachadas, patios, divisiones, terrazas y zonas de transición.",
          "Permiten especificar una piel material con identidad en residencial, comercial y hospitality.",
        ],
        applicationsTitle: "Aplicaciones recomendadas",
        applications: ["Fachadas", "Privacidad", "Divisiones arquitectónicas", "Ventilación pasiva"],
        faqTitle: "Preguntas frecuentes sobre celosías de concreto",
        faq: [
          {
            question: "¿Las celosías solo sirven para exterior?",
            answer: "No. Además de fachadas y patios, pueden usarse en divisiones interiores, terrazas y proyectos donde se busque filtrar visuales o crear capas espaciales.",
          },
          {
            question: "¿Ayudan a controlar luz y ventilación?",
            answer: "Sí. Su principal valor es modular la entrada de luz, permitir ventilación y aumentar privacidad con una solución arquitectónica elegante.",
          },
          {
            question: "¿Pueden convivir con paneles o revestimientos?",
            answer: "Sí. Son ideales para sistemas mixtos donde celosías, paneles y muros comparten un mismo lenguaje material.",
          },
        ],
      },
      "es-ES": {
        seoTitle: "Celosías de hormigón para fachadas | Arista + Vértice",
        seoDescription:
          "Explora celosías de hormigón para fachadas, filtros visuales, ventilación y privacidad. Soluciones arquitectónicas premium con luz, sombra y profundidad.",
        keywords: ["celosías de hormigón", "fachadas arquitectónicas", "divisiones", "concrete screens"],
        kicker: "Landing SEO",
        title: "Celosías de hormigón para fachadas con ritmo, luz y sombra.",
        intro:
          "Las celosías de Arista + Vértice convierten la envolvente arquitectónica en una superficie activa: filtran la luz, aportan privacidad y construyen un gesto formal con carácter premium.",
        benefitsTitle: "Valor para el proyecto",
        benefits: [
          "Mejoran la relación entre sombra, ventilación y privacidad sin renunciar a la expresión arquitectónica.",
          "Funcionan en fachadas, patios, divisiones, terrazas y zonas de transición.",
          "Permiten prescribir una piel material con identidad en residencial, comercial y hospitality.",
        ],
        applicationsTitle: "Aplicaciones recomendadas",
        applications: ["Fachadas", "Privacidad", "Divisiones arquitectónicas", "Ventilación pasiva"],
        faqTitle: "Preguntas frecuentes sobre celosías de hormigón",
        faq: [
          {
            question: "¿Las celosías solo sirven para exterior?",
            answer: "No. Además de fachadas y patios, pueden emplearse en divisiones interiores, terrazas y proyectos donde se busque filtrar visuales o crear capas espaciales.",
          },
          {
            question: "¿Ayudan a controlar luz y ventilación?",
            answer: "Sí. Su principal valor es modular la entrada de luz, permitir ventilación y aumentar privacidad con una solución arquitectónica elegante.",
          },
          {
            question: "¿Pueden convivir con paneles o revestimientos?",
            answer: "Sí. Son ideales para sistemas mixtos donde celosías, paneles y muros comparten un mismo lenguaje material.",
          },
        ],
      },
      "en-US": {
        seoTitle: "Concrete screens for facades and privacy | Arista + Vértice",
        seoDescription:
          "Explore concrete screens for facades, privacy walls, airflow and light control. Premium architectural systems with strong rhythm, depth and material presence.",
        keywords: ["concrete screens", "breeze blocks", "architectural facade screens", "privacy screens"],
        kicker: "SEO landing",
        title: "Concrete screens for facades shaped by light, shadow and airflow.",
        intro:
          "Arista + Vértice concrete screens turn the architectural envelope into an active surface that balances privacy, ventilation and visual rhythm.",
        benefitsTitle: "Project value",
        benefits: [
          "They help control sunlight, airflow and privacy with a premium architectural language.",
          "They work across facades, patios, partitions, terraces and transition zones.",
          "They create a memorable material identity in residential, commercial and hospitality projects.",
        ],
        applicationsTitle: "Recommended applications",
        applications: ["Facades", "Privacy walls", "Architectural dividers", "Passive ventilation"],
        faqTitle: "Frequently asked questions about concrete screens",
        faq: [
          {
            question: "Are concrete screens only for exterior use?",
            answer: "No. They can also be used indoors as partitions, transition elements or design features that filter views and create spatial depth.",
          },
          {
            question: "Do they help with light and ventilation?",
            answer: "Yes. One of their main advantages is controlling sunlight while allowing airflow and preserving privacy.",
          },
          {
            question: "Can they work with wall panels or cladding?",
            answer: "Yes. They are especially powerful when integrated into a broader material system with panels and wall finishes.",
          },
        ],
      },
    },
  },
  "paneles-de-concreto": {
    heroCollectionId: "paneles",
    relatedCollectionIds: ["paneles", "muro", "celosias"],
    locales: {
      "es-MX": {
        seoTitle: "Paneles de concreto arquitectónico | Arista + Vértice",
        seoDescription:
          "Paneles de concreto arquitectónico para fachadas, muros y superficies de gran formato. Materiales premium para arquitectos, interioristas y desarrolladores.",
        keywords: ["paneles de concreto", "paneles arquitectónicos", "decorative concrete panels", "revestimientos"],
        kicker: "Landing SEO",
        title: "Paneles de concreto para superficies limpias, contemporáneas y memorables.",
        intro:
          "Los paneles de concreto de Arista + Vértice resuelven muros y fachadas con una lectura continua, contemporánea y de alta precisión material, pensada para proyectos de alto valor visual.",
        benefitsTitle: "Ventajas clave",
        benefits: [
          "Aportan orden visual y una escala arquitectónica clara en interiores y envolventes.",
          "Permiten especificar grandes superficies con un lenguaje material sobrio y premium.",
          "Son ideales para retail, hospitality, residencial y desarrollos de imagen cuidada.",
        ],
        applicationsTitle: "Dónde funcionan mejor",
        applications: ["Fachadas", "Muros interiores", "Recepciones", "Comercial / hospitality"],
        faqTitle: "Preguntas frecuentes sobre paneles de concreto",
        faq: [
          {
            question: "¿Qué aporta un panel de concreto frente a otras soluciones decorativas?",
            answer: "Aporta continuidad, presencia material y un acabado más arquitectónico, útil para superficies donde el muro debe sentirse sólido, ordenado y premium.",
          },
          {
            question: "¿Sirven para interior y exterior?",
            answer: "Sí. Según la colección, pueden funcionar en fachadas, muros interiores, lobbies, recepciones y proyectos residenciales o comerciales.",
          },
          {
            question: "¿Se pueden personalizar?",
            answer: "Sí. Arista + Vértice trabaja con color, textura, acabados y combinaciones para adaptar el sistema material al proyecto.",
          },
        ],
      },
      "es-ES": {
        seoTitle: "Paneles de hormigón arquitectónico | Arista + Vértice",
        seoDescription:
          "Paneles de hormigón arquitectónico para fachadas, muros y superficies de gran formato. Materiales premium para arquitectos, interioristas y promotores.",
        keywords: ["paneles de hormigón", "paneles arquitectónicos", "decorative concrete panels", "revestimientos"],
        kicker: "Landing SEO",
        title: "Paneles de hormigón para superficies limpias, contemporáneas y memorables.",
        intro:
          "Los paneles de hormigón de Arista + Vértice resuelven muros y fachadas con una lectura continua, contemporánea y de alta precisión material, pensada para proyectos de alto valor visual.",
        benefitsTitle: "Ventajas clave",
        benefits: [
          "Aportan orden visual y una escala arquitectónica clara en interiores y envolventes.",
          "Permiten prescribir grandes superficies con un lenguaje material sobrio y premium.",
          "Son ideales para retail, hospitality, residencial y promociones de imagen cuidada.",
        ],
        applicationsTitle: "Dónde funcionan mejor",
        applications: ["Fachadas", "Muros interiores", "Recepciones", "Comercial / hospitality"],
        faqTitle: "Preguntas frecuentes sobre paneles de hormigón",
        faq: [
          {
            question: "¿Qué aporta un panel de hormigón frente a otras soluciones decorativas?",
            answer: "Aporta continuidad, presencia material y un acabado más arquitectónico, útil para superficies donde el muro debe sentirse sólido, ordenado y premium.",
          },
          {
            question: "¿Sirven para interior y exterior?",
            answer: "Sí. Según la colección, pueden funcionar en fachadas, muros interiores, lobbies, recepciones y proyectos residenciales o comerciales.",
          },
          {
            question: "¿Se pueden personalizar?",
            answer: "Sí. Arista + Vértice trabaja con color, textura, acabados y combinaciones para adaptar el sistema material al proyecto.",
          },
        ],
      },
      "en-US": {
        seoTitle: "Decorative concrete panels for walls and facades | Arista + Vértice",
        seoDescription:
          "Discover decorative concrete panels for walls, facades and large-format surfaces. Premium architectural materials for designers, developers and specifiers.",
        keywords: ["decorative concrete panels", "architectural concrete panels", "concrete wall cladding", "facade panels"],
        kicker: "SEO landing",
        title: "Decorative concrete panels for clean, contemporary architectural surfaces.",
        intro:
          "Arista + Vértice concrete panels help define walls and facades with continuity, precision and a premium material presence suited to design-led projects.",
        benefitsTitle: "Key advantages",
        benefits: [
          "They create visual order and a clear architectural scale across interior and exterior surfaces.",
          "They help specify large-format walls with a refined, premium material language.",
          "They fit retail, hospitality, residential and developer-led projects with strong aesthetic standards.",
        ],
        applicationsTitle: "Where they work best",
        applications: ["Facades", "Interior walls", "Reception areas", "Retail and hospitality"],
        faqTitle: "Frequently asked questions about decorative concrete panels",
        faq: [
          {
            question: "What do decorative concrete panels offer compared to lighter decorative cladding?",
            answer: "They provide stronger material presence, architectural continuity and a more premium tactile reading for feature walls and facades.",
          },
          {
            question: "Can they be used indoors and outdoors?",
            answer: "Yes. Depending on the collection, they can be specified for facades, interior walls, lobbies, reception areas and hospitality environments.",
          },
          {
            question: "Can they be customized?",
            answer: "Yes. Arista + Vértice works with color, texture and finish options to align the material system with each project.",
          },
        ],
      },
    },
  },
  "wall-tiles": {
    heroCollectionId: "muro",
    relatedCollectionIds: ["muro", "paneles", "pisos"],
    locales: {
      "en-US": {
        seoTitle: "Wall tiles for interior design and facades | Arista + Vértice",
        seoDescription:
          "Explore wall tiles and concrete wall finishes for premium interior design, decorative walls and facade projects. Material-led collections for architects and designers.",
        keywords: ["wall tiles", "concrete wall tiles", "decorative wall tiles", "architectural wall finishes"],
        kicker: "SEO landing",
        title: "Wall tiles with a premium material expression for interiors and facades.",
        intro:
          "This page groups Arista + Vértice solutions for searchers looking for wall tiles with an architectural, sculptural and emotionally resonant concrete language.",
        benefitsTitle: "Why they stand out",
        benefits: [
          "They bridge interior design and architectural performance through texture, rhythm and depth.",
          "They work for premium residences, hospitality, retail and design-led commercial spaces.",
          "They give specifiers access to a more distinctive concrete finish vocabulary than standard wall cladding.",
        ],
        applicationsTitle: "Best-fit applications",
        applications: ["Feature walls", "Hospitality interiors", "Retail design", "Facade accents"],
        faqTitle: "Frequently asked questions about wall tiles",
        faq: [
          {
            question: "Are these wall tiles only decorative?",
            answer: "No. While they are highly expressive, they are also part of a broader architectural material system designed for durability and specification.",
          },
          {
            question: "What makes them premium?",
            answer: "Their value comes from material depth, refined geometry, curated finishes and the ability to create more memorable walls and surfaces.",
          },
          {
            question: "Can designers request catalogs before specifying?",
            answer: "Yes. Each landing closes with direct access to catalog downloads and commercial guidance by WhatsApp.",
          },
        ],
      },
    },
  },
  "concrete-screens": {
    heroCollectionId: "celosias",
    relatedCollectionIds: ["celosias", "paneles", "muro"],
    locales: {
      "en-US": {
        seoTitle: "Concrete screens for facades and privacy walls | Arista + Vértice",
        seoDescription:
          "Concrete screens for facades, privacy walls and airflow-driven architecture. Explore premium breeze block systems with light, shadow and sculptural rhythm.",
        keywords: ["concrete screens", "breeze blocks", "facade screens", "privacy walls"],
        kicker: "SEO landing",
        title: "Concrete screens for facades, privacy and architectural rhythm.",
        intro:
          "Arista + Vértice concrete screens are designed for architects and designers who need more than a wall: they need light control, airflow and a stronger facade identity.",
        benefitsTitle: "Why designers choose them",
        benefits: [
          "They create depth and a memorable facade language without closing off airflow.",
          "They support privacy needs while maintaining porosity and visual rhythm.",
          "They work beautifully in residential, hospitality and commercial environments.",
        ],
        applicationsTitle: "Best-fit applications",
        applications: ["Privacy walls", "Facade systems", "Terraces and patios", "Architectural dividers"],
        faqTitle: "Frequently asked questions about concrete screens",
        faq: [
          {
            question: "Do concrete screens help with privacy?",
            answer: "Yes. They are ideal for projects that need privacy without losing airflow, daylight or architectural expression.",
          },
          {
            question: "Can they be used as facade systems?",
            answer: "Yes. They are especially effective on facades, transition zones, patios and semi-exterior spaces where light and shadow matter.",
          },
          {
            question: "Are these the same as basic breeze blocks?",
            answer: "They share a similar logic, but Arista + Vértice positions them within a more curated, premium architectural material system.",
          },
        ],
      },
    },
  },
  "revestimientos-para-muros": {
    heroCollectionId: "muro",
    relatedCollectionIds: ["muro", "paneles", "celosias"],
    locales: {
      "es-MX": {
        seoTitle: "Revestimientos para muros de concreto | Arista + Vértice",
        seoDescription:
          "Revestimientos para muros de concreto para interiorismo, muros decorativos y fachadas arquitectónicas. Explora soluciones premium para arquitectos e interioristas.",
        keywords: ["revestimientos para muros", "recubrimientos para muros", "revestimientos de concreto", "muros decorativos"],
        kicker: "Landing SEO",
        title: "Revestimientos para muros con textura, volumen y lenguaje arquitectónico.",
        intro:
          "Esta landing sintetiza cómo Arista + Vértice trabaja el revestimiento mural desde una lógica material premium: relieves, paneles y superficies capaces de transformar un muro en una experiencia espacial.",
        benefitsTitle: "Qué aportan al proyecto",
        benefits: [
          "Elevan la lectura del muro con textura, profundidad y una presencia material más sofisticada.",
          "Ayudan a definir atmósfera en interiorismo residencial, hospitality, retail y espacios corporativos.",
          "Permiten integrar luz, sombra y detalle en superficies continuas o composiciones más escultóricas.",
        ],
        applicationsTitle: "Usos frecuentes",
        applications: ["Muros interiores", "Muros decorativos", "Lobbies y recepciones", "Fachadas"],
        faqTitle: "Preguntas frecuentes sobre revestimientos para muros",
        faq: [
          { question: "¿Qué tipo de proyectos los usan más?", answer: "Principalmente residencial premium, hospitality, retail, espacios corporativos y fachadas donde el muro necesita aportar identidad visual." },
          { question: "¿Pueden convivir con paneles y celosías?", answer: "Sí. De hecho, muchas composiciones de Arista + Vértice funcionan mejor cuando el revestimiento mural convive con paneles o celosías del mismo sistema material." },
          { question: "¿Se pueden personalizar?", answer: "Sí. Color, textura, acabados y combinaciones se trabajan para alinear el material con la narrativa del proyecto." },
        ],
      },
      "es-ES": {
        seoTitle: "Revestimientos para muros de hormigón | Arista + Vértice",
        seoDescription:
          "Revestimientos para muros de hormigón para interiorismo, muros decorativos y fachadas arquitectónicas. Explora soluciones premium para arquitectos e interioristas.",
        keywords: ["revestimientos para muros", "revestimientos de hormigón", "muros decorativos", "acabados arquitectónicos"],
        kicker: "Landing SEO",
        title: "Revestimientos para muros con textura, volumen y lenguaje arquitectónico.",
        intro:
          "Esta landing sintetiza cómo Arista + Vértice trabaja el revestimiento mural desde una lógica material premium: relieves, paneles y superficies capaces de transformar un muro en una experiencia espacial.",
        benefitsTitle: "Qué aportan al proyecto",
        benefits: [
          "Elevan la lectura del muro con textura, profundidad y una presencia material más sofisticada.",
          "Ayudan a definir atmósfera en interiorismo residencial, hospitality, retail y espacios corporativos.",
          "Permiten integrar luz, sombra y detalle en superficies continuas o composiciones más escultóricas.",
        ],
        applicationsTitle: "Usos frecuentes",
        applications: ["Muros interiores", "Muros decorativos", "Lobbies y recepciones", "Fachadas"],
        faqTitle: "Preguntas frecuentes sobre revestimientos para muros",
        faq: [
          { question: "¿Qué tipo de proyectos los emplean más?", answer: "Principalmente residencial premium, hospitality, retail, espacios corporativos y fachadas donde el muro debe aportar identidad visual." },
          { question: "¿Pueden convivir con paneles y celosías?", answer: "Sí. Muchas composiciones de Arista + Vértice funcionan mejor cuando el revestimiento mural convive con paneles o celosías del mismo sistema material." },
          { question: "¿Se pueden personalizar?", answer: "Sí. Color, textura, acabados y combinaciones se trabajan para alinear el material con la narrativa del proyecto." },
        ],
      },
      "en-US": {
        seoTitle: "Concrete wall cladding and wall finishes | Arista + Vértice",
        seoDescription:
          "Concrete wall cladding and wall finishes for feature walls, premium interiors and architectural facades. Discover refined material systems for design-led projects.",
        keywords: ["concrete wall cladding", "wall finishes", "architectural wall finishes", "decorative walls"],
        kicker: "SEO landing",
        title: "Wall cladding and finishes with texture, depth and architectural character.",
        intro:
          "This landing page frames Arista + Vértice wall solutions as a premium answer for designers and architects looking for more expressive wall finishes.",
        benefitsTitle: "What they bring to a project",
        benefits: [
          "They turn walls into design elements with more depth, rhythm and tactile presence.",
          "They work across residential interiors, hospitality, retail and facade applications.",
          "They help teams specify a clearer premium material language beyond standard cladding.",
        ],
        applicationsTitle: "Frequent use cases",
        applications: ["Interior walls", "Feature walls", "Lobbies and receptions", "Facades"],
        faqTitle: "Frequently asked questions about wall cladding and finishes",
        faq: [
          { question: "Where do these finishes work best?", answer: "They are especially strong in design-led interiors, hospitality, retail spaces and facades where the wall must deliver identity." },
          { question: "Can they be mixed with screens or panels?", answer: "Yes. Many Arista + Vértice compositions become more powerful when wall finishes are paired with screens or panel systems." },
          { question: "Can the finish palette be customized?", answer: "Yes. Color, texture and finish options can be adjusted to match the aesthetic direction of the project." },
        ],
      },
    },
  },
  "acabados-arquitectonicos": {
    heroCollectionId: "paneles",
    relatedCollectionIds: ["paneles", "muro", "pisos"],
    locales: {
      "es-MX": {
        seoTitle: "Acabados arquitectónicos de concreto | Arista + Vértice",
        seoDescription:
          "Acabados arquitectónicos de concreto para muros, fachadas e interiorismo. Colecciones premium para proyectos de lujo silencioso, textura y sofisticación material.",
        keywords: ["acabados arquitectónicos", "acabados de concreto", "arquitectura", "interiorismo"],
        kicker: "Landing SEO",
        title: "Acabados arquitectónicos con una lectura material precisa y emocional.",
        intro:
          "Arista + Vértice entiende el acabado arquitectónico como una capa de identidad: no solo reviste, también comunica atmósfera, profundidad y carácter en espacios premium.",
        benefitsTitle: "Cómo elevan un proyecto",
        benefits: [
          "Permiten construir una narrativa material coherente entre muros, fachadas y superficies interiores.",
          "Aportan riqueza táctil y una estética contemporánea alejada de soluciones genéricas.",
          "Facilitan la especificación de materiales para arquitectos, interioristas y desarrolladores.",
        ],
        applicationsTitle: "Ámbitos de aplicación",
        applications: ["Interiorismo", "Fachadas", "Hospitality", "Residencial premium"],
        faqTitle: "Preguntas frecuentes sobre acabados arquitectónicos",
        faq: [
          { question: "¿Qué hace premium a un acabado arquitectónico?", answer: "Su capacidad de sostener una lectura material más profunda, con mejor textura, detalle, composición y coherencia con el proyecto." },
          { question: "¿Aplica solo a muros?", answer: "No. También puede extenderse a fachadas, superficies de transición, lobbies, recepciones y piezas decorativas de alto impacto." },
          { question: "¿Puedo ver opciones por colección?", answer: "Sí. Desde esta landing puedes navegar a muro, paneles, pisos y catálogos para revisar familias completas." },
        ],
      },
      "es-ES": {
        seoTitle: "Acabados arquitectónicos de hormigón | Arista + Vértice",
        seoDescription:
          "Acabados arquitectónicos de hormigón para muros, fachadas e interiorismo. Colecciones premium para proyectos de lujo silencioso, textura y sofisticación material.",
        keywords: ["acabados arquitectónicos", "acabados de hormigón", "arquitectura", "interiorismo"],
        kicker: "Landing SEO",
        title: "Acabados arquitectónicos con una lectura material precisa y emocional.",
        intro:
          "Arista + Vértice entiende el acabado arquitectónico como una capa de identidad: no solo reviste, también comunica atmósfera, profundidad y carácter en espacios premium.",
        benefitsTitle: "Cómo elevan un proyecto",
        benefits: [
          "Permiten construir una narrativa material coherente entre muros, fachadas y superficies interiores.",
          "Aportan riqueza táctil y una estética contemporánea alejada de soluciones genéricas.",
          "Facilitan la prescripción de materiales para arquitectos, interioristas y promotores.",
        ],
        applicationsTitle: "Ámbitos de aplicación",
        applications: ["Interiorismo", "Fachadas", "Hospitality", "Residencial premium"],
        faqTitle: "Preguntas frecuentes sobre acabados arquitectónicos",
        faq: [
          { question: "¿Qué hace premium a un acabado arquitectónico?", answer: "Su capacidad de sostener una lectura material más profunda, con mejor textura, detalle, composición y coherencia con el proyecto." },
          { question: "¿Aplica solo a muros?", answer: "No. También puede extenderse a fachadas, superficies de transición, lobbies, recepciones y piezas decorativas de alto impacto." },
          { question: "¿Puedo ver opciones por colección?", answer: "Sí. Desde esta landing puedes navegar a muro, paneles, suelos y catálogos para revisar familias completas." },
        ],
      },
      "en-US": {
        seoTitle: "Architectural concrete finishes for premium projects | Arista + Vértice",
        seoDescription:
          "Architectural concrete finishes for walls, facades and interior design. Explore premium material systems shaped by texture, depth and quiet luxury.",
        keywords: ["architectural concrete finishes", "premium concrete finishes", "interior design materials", "architectural materials"],
        kicker: "SEO landing",
        title: "Architectural finishes with emotional depth and premium material precision.",
        intro:
          "Arista + Vértice approaches architectural finishes as identity layers: they do not simply cover a surface, they define mood, depth and material character.",
        benefitsTitle: "How they elevate a project",
        benefits: [
          "They help create a coherent material language across walls, facades and interior surfaces.",
          "They deliver tactile richness and a more contemporary, non-generic finish vocabulary.",
          "They support architects, interior designers and developers with a more specification-ready premium system.",
        ],
        applicationsTitle: "Application scope",
        applications: ["Interior design", "Facades", "Hospitality", "Premium residential"],
        faqTitle: "Frequently asked questions about architectural concrete finishes",
        faq: [
          { question: "What makes an architectural finish feel premium?", answer: "Its ability to hold a stronger material reading through texture, detail, composition and alignment with the broader design concept." },
          { question: "Are these finishes only for walls?", answer: "No. They can extend to facades, transition zones, lobbies, reception spaces and other high-impact architectural surfaces." },
          { question: "Can I explore related collections from here?", answer: "Yes. This page links directly to relevant collections and catalogs for deeper specification work." },
        ],
      },
    },
  },
  "decorative-concrete-panels": {
    heroCollectionId: "paneles",
    relatedCollectionIds: ["paneles", "muro", "celosias"],
    locales: {
      "en-US": {
        seoTitle: "Decorative concrete panels for premium projects | Arista + Vértice",
        seoDescription:
          "Decorative concrete panels for walls, facades and feature surfaces. Discover premium architectural materials for designers, developers and specification teams.",
        keywords: ["decorative concrete panels", "concrete panels", "feature wall panels", "architectural concrete panels"],
        kicker: "SEO landing",
        title: "Decorative concrete panels for feature walls, facades and high-value surfaces.",
        intro:
          "This landing page focuses on decorative concrete panels as a premium architectural tool for shaping surfaces with clarity, depth and contemporary refinement.",
        benefitsTitle: "Why they matter",
        benefits: [
          "They give large surfaces a cleaner, more intentional architectural expression.",
          "They work for designers who need stronger material identity across walls and facades.",
          "They support premium residential, retail and hospitality environments with a specification-ready system.",
        ],
        applicationsTitle: "Ideal applications",
        applications: ["Feature walls", "Facade panels", "Reception spaces", "Hospitality"],
        faqTitle: "Frequently asked questions about decorative concrete panels",
        faq: [
          { question: "How are decorative concrete panels different from lighter wall panels?", answer: "They provide a more architectural, tactile and premium material presence, especially valuable in feature walls and facades." },
          { question: "Can they be mixed with wall tiles?", answer: "Yes. Decorative panels and wall tiles can coexist within the same material narrative depending on the desired rhythm and scale." },
          { question: "Are they suitable for commercial projects?", answer: "Yes. They are especially useful in hospitality, retail, branded environments and premium residential projects." },
        ],
      },
    },
  },
  "architectural-concrete-finishes": {
    heroCollectionId: "muro",
    relatedCollectionIds: ["muro", "paneles", "pisos"],
    locales: {
      "en-US": {
        seoTitle: "Architectural concrete finishes for walls and facades | Arista + Vértice",
        seoDescription:
          "Architectural concrete finishes for walls, facades and premium interiors. Explore refined material systems for architects, interior designers and developers.",
        keywords: ["architectural concrete finishes", "concrete finishes", "premium wall finishes", "design materials"],
        kicker: "SEO landing",
        title: "Architectural concrete finishes for walls, facades and premium interiors.",
        intro:
          "This page translates Arista + Vértice into a clearer search destination for teams looking specifically for architectural concrete finishes with a premium editorial sensibility.",
        benefitsTitle: "What they unlock",
        benefits: [
          "A more distinctive finish language for walls, facades and transition surfaces.",
          "A premium material system that supports quiet luxury, texture and architectural depth.",
          "A better bridge between aesthetic aspiration and specification-ready product families.",
        ],
        applicationsTitle: "Typical project uses",
        applications: ["Premium interiors", "Feature walls", "Architectural facades", "Hospitality"],
        faqTitle: "Frequently asked questions about architectural concrete finishes",
        faq: [
          { question: "Why search specifically for architectural concrete finishes?", answer: "Because the term reflects a more design-led, specification-focused material approach than generic concrete products." },
          { question: "Can these finishes support luxury interiors?", answer: "Yes. They are especially relevant for projects built around texture, calm atmosphere and strong material presence." },
          { question: "Do they include multiple product families?", answer: "Yes. This landing connects to wall collections, panel systems, facades and related catalogs so teams can evaluate the full material ecosystem." },
        ],
      },
    },
  },
};

export const getSeoLandingContent = (slug, locale) => {
  const landing = LANDING_CONTENT[slug];
  if (!landing) {
    return null;
  }

  const content = landing.locales[locale] || landing.locales["es-MX"] || landing.locales["en-US"];
  return {
    slug,
    heroCollectionId: landing.heroCollectionId,
    relatedCollectionIds: landing.relatedCollectionIds,
    ...content,
  };
};

export const getSeoLandingSlugs = () => Object.keys(LANDING_CONTENT);
